<template>
  <div>
    <div id="chart-container" class="by-winners">
      <div v-show="this.$parent.getDisplayView() && getDisplayView()" id="cp-by-winners-title-and-e-chart" class="chart-row">
        <profile-chart-header
          :title="'Winners Map'"
          :display="this.$parent.getDisplayView() && getDisplayView()"
          :input-display-number-of-responses="eChartCriteria.displayNumberOfResponses"
          :input-show-tooltip="eChartCriteria.showTooltip"
          @set-display-number-of-responses="setDisplayNumberOfResponses"
          @set-show-tooltip="setShowTooltip"
        />               
        <profile-chart ref="eChart"
            :e-chart-mini-id="'profile-match-chart-winners-mini'"
            :e-chart-id="'profile-match-chart-winners'"
            :input-report-type-name="'Chart - Match Winners Map'"
            :modal-id="'profile-by-winners-chart'"
            :is-saved-card="$parent.clientChart.clientChartId != 0" 
            :input-client-chart="this.$parent.clientChart"
            :inputDownloadFileName="'Match Winners Map'"
            @save-table="saveProfileDataTable"
            @save-criteria="buildClientChart"/>        
      </div>      
      <div v-show="this.$parent.getDisplayView() && getDisplayView()" :id="winnersMapTable.tableContainerId" :class="isInsiderUser ? 'chart-data hide-table-data' : 'chart-data'">
        <div v-show="isInsiderUser" class="overlay">
          <img class="overlay-inner" v-show="isInsiderUser" src="../../../assets/img/overlap.png" style="width: 50%"/>
        </div>
        <chart-data-table
          ref="winnersDataTable"
          v-show="this.$parent.getDisplayView() && getDisplayView()"
          :chart-data="this.winnersMapTable.data"
          :display-direction="'vertical'"
          :data-container-id="winnersMapTable.tableContainerId"
          :container-id="'profile_match_winners_conserve_effort_chart'"
          :column-defs="this.chart.columnDefs"
          :table-class="'table display row-border table-hover'"
          :table-width="'auto'"
          :is-saved-card="$parent.clientChart.clientChartId != 0" 
          :report-page-type-name="'Table - Match Winners Map'"
          :insight-modal-id="'profile-by-winners-table'"
          :content-list="this.pageContentForWinners"
          :table-title="this.winnersMapTable.title"
          :inputDownloadFileName="'Match Winners Map'"
        ></chart-data-table>
      </div>
    </div>
    <insights
      ref="insightsChart"
      :modal-name="'profile-by-winners-chart'"
      :report-page-type-name="'Chart - Match Winners Map'"
      :entry-page-content="this.pageContentForReport"
      @saveReportPage="$parent.updateReportPages"
      @saveAllReportPages="saveAllReportPages"
      @saveClientChart="$parent.saveClientChart"
    />
    <insights
      ref="insightsTable"
      :modal-name="'profile-by-winners-table'"
      :report-page-type-name="'Table - Match Winners Map'"
      :entry-page-content="this.pageContentForReport"
      @saveReportPage="$parent.updateReportPages"
      @saveAllReportPages="saveAllReportPages"
      @saveClientChart="$parent.saveClientChart"
    />
  </div>
</template>
<script>
import $ from "jquery";
import ProfileChart from "../../../views/echarts/ProfileChart.vue";
import ProfileChartHeader from "../../../components/echarts/ProfileChartHeader.vue";
import ProfileService from "../../../services/echarts/profile.service";

import ChartCompanyMixins from "../../../mixins/ChartCompanyMixins.vue";
import ChartService from "../../../services/chart.service";
import ErrorService from "../../../services/error.service";
import AdminService from "../../../services/admin.service";
import NeedsService from "../../../services/needs.service";
import TableService from "../../../services/table.service";
import ReportService from "../../../services/report.service";
import ContentService from "../../../services/content.service";

export default {
  name: "MatchByWinners",
  mixins: [ChartCompanyMixins],
  components: {ProfileChart, ProfileChartHeader},

  data() {
    return {
      displayType: "match-winner",
      pageContentForWinners: [],
      winnersConserveEffortData: {},
      winnersCoreEffortData: {},
      winnersDivergeEffortData: {},
      winnersMapTable: {
        id: "",
        data: {},
        tableContainerId: "profile_by_winners_data_container",
        title: '<div class="title"><h4 class="text-primary">Winners Map</h4></div>'
      },
      isMobile: false,
      needsList: [],
    };
  },
  props: {
    chartData: {
      type: Array,
      default: function() {
        return [];
      }
    },
    contentList: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  computed: {
    surveyCode: function() {
      return this.$parent.$data.survey.surveyCode;
    },    

  },
  mounted() {},
  created() {
    ContentService.getPageContent("Winners", this.getPageContentByWinnersCallBack, this);    
  },
  methods: {
    getPageContentByWinnersCallBack(response) {
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        this.pageContentForWinners = response.data.data;
        this.pageContentForWinners.push(...this.contentList);
      }
    },       
    displayInsights(insightModalId, reportPageTypeName) {
      if (reportPageTypeName == "Chart - Match Winners Map") {
        this.$refs.insightsChart.reportPageInput = ReportService.getReportPage(reportPageTypeName, this.$parent.reportPagesList);
        this.$refs.insightsChart.initializeInsights(this.$parent.clientChart);
        this.$modal.show(insightModalId);
      } else if (reportPageTypeName == "Table - Match Winners Map") {
        this.$refs.insightsTable.reportPageInput = ReportService.getReportPage(reportPageTypeName, this.$parent.reportPagesList);
        this.$refs.insightsTable.initializeInsights(this.$parent.clientChart);
        this.$modal.show(insightModalId);
      }
    },
    async processChartData() {
      try {
        this.chart = ChartService.getChartAttributes("Match By Winners");
        this.$parent.pageContent.push(...this.contentList);
        let needsData = JSON.parse(JSON.stringify(this.chartData[0]));
        let otherData = needsData["otherData"];
        

        let moatsList = otherData["moatsList"];

        this.needsList = otherData["needsList"];
        let companyColorList = otherData["companyColorList"];
        TableService.setCompanyColorList(companyColorList);

        let dynamicChartOptions = needsData["options"];
        let containerId = needsData["containerId"];
        this.winnersConserveEffortData = this.drawSingleEmotionalNeedsName(JSON.parse(JSON.stringify(this.chartData[0])));

        let chartContainerWidth = $("#" + containerId).width();
        if (chartContainerWidth < ChartService.getMobileBreakpoint()) {
          this.isMobile = true;
        } else {
          this.isMobile = false;
        }

        this.table.id = containerId;

        NeedsService.setFunctionalNeedsList(this.needsList);
        NeedsService.setEmotionalNeedsList(this.needsList);
        NeedsService.setMoatsList(moatsList);
        let copyOfChartData = JSON.parse(JSON.stringify(needsData));
        this.winnersCoreEffortData = this.drawSingleEmotionalNeedsName(JSON.parse(JSON.stringify(this.chartData[1])));
        this.winnersDivergeEffortData = this.drawSingleEmotionalNeedsName(JSON.parse(JSON.stringify(this.chartData[2])));

        // for AI Profile Recommendations
        this.setRecommendationsData(needsData, true);
        
        let originalWinnersCoreData = JSON.parse(JSON.stringify(this.chartData[1]));
        copyOfChartData.rows.push(...originalWinnersCoreData.rows);
        let originalWinnersDivergeData = JSON.parse(JSON.stringify(this.chartData[2]));
        copyOfChartData.rows.push(...originalWinnersDivergeData.rows);

        this.$parent.setChartResults(needsData.companyList);
        this.$parent.$data.criteriaResultsList = AdminService.removeByName(needsData.criteriaList, "Competitor");

        this.winnersConserveEffortData = this.drawSingleEmotionalNeedsName(needsData);
        this.winnersMapTable.id = containerId;
        this.winnersMapTable.data = copyOfChartData;

          
        this.$root.$emit("check-number-of-responses");
        this.setDisplayView(true);
        this.$parent.setDisplayView(true);
        this.setEChartCriteria(this.$parent.$refs.chartCriteria.eChartCriteria);
        this.eChartCriteria.eChartType = "stacked-bar-vertical";        
        this.parseMatchProfileDataForWinner(JSON.parse(JSON.stringify(this.chartData)));
        this.$refs.eChart.processChart(true,"match-winner",this.eChartData,this.eChartCriteria,this.$parent.showPricingPower,this.$parent.$refs.chartCriteria.matchType);
        $("#cp-by-winners-title-and-e-chart").addClass("chart-wrapper");

      } catch (err) {
        ErrorService.processException("MatchByWinners.displayChartCallback", err, "chart", this);
      }
    },
    parseMatchProfileDataForWinner: function(inputData){
      let itemsToRemove = {
        firstColumns: 1,
      };
      let data = {};
      let chart1Data = inputData[0];
      let chart2Data = inputData[1];
      let chart3Data = inputData[2];
      let mergedRows = [...chart1Data.rows, ...chart2Data.rows, ...chart3Data.rows];
      chart1Data.rows = mergedRows;
      data = ProfileService.parseData(1,chart1Data,data,itemsToRemove);
      data = ProfileService.parseLegendAndColorData(inputData[0],data,false);
      this.eChartData = JSON.parse(JSON.stringify(data));
    },    
    saveAllReportPages() {
      this.saveProfileDataTable();
    },   
    async saveProfileDataTable() {
      if (this.$parent.clientChart.clientChartId != 0 && this.isGenerateReportRunning()) {
        let vm = this;
        setTimeout(function() {
          ReportService.saveReportTableFile(vm.$refs.winnersDataTable.getTableData(),"Table - Match Winners Map",vm.$parent.clientChart,vm.saveReportTableFileCallback,vm);
          ReportService.saveReportPage(vm.getReportTableContent("profile_match_winners_conserve_effort_chart"),"Table - Match Winners Map",vm.$parent.clientChart,vm.saveReportPageCallback,vm);
        }, 1500);  
      }
    },      
  },
  watch: {
    surveyCode: function() {
      /* eslint no-empty: ["error", { "allowEmptyCatch": true }] */
      try{this.$refs.eChart.clear();} catch(e){}
    },
    chartData: function() {
      if (this.$parent.isMatchByWinners) {
        this.processChartData();
      } else {
        this.setDisplayView(false);
      }
    }
  }
};
</script>
